import PropTypes from 'prop-types'
import classNames from 'classnames'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import styles from './CopyableValue.module.scss'

const CopyableValue = ({ value, label, className }) => {
  const { t } = useTranslation()

  const handleCopy = (e) => {
    e.preventDefault()
    e.stopPropagation()

    navigator.clipboard.writeText(String(value))
    toast.success(t('common.action.copiedValue', { label }), { position: toast.POSITION.BOTTOM_LEFT })
  }

  const copyLabel = t('common.action.copyValue', { label })

  return (
    <button
      className={classNames(styles.copyableValue, 'p-0 border-0 bg-transparent text-left', className)}
      onClick={handleCopy}
      title={copyLabel}
      aria-label={copyLabel}
    >
      {value}
    </button>
  )
}

CopyableValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default CopyableValue
